/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as ResetPasswordRouteImport } from "./routes/reset-password"
import { Route as LoginRouteImport } from "./routes/login"
import { Route as ForgotPasswordRouteImport } from "./routes/forgot-password"
import { Route as AuthenticatedRouteImport } from "./routes/_authenticated"
import { Route as AuthenticatedIndexRouteImport } from "./routes/_authenticated/index"
import { Route as ReportTokenRouteImport } from "./routes/report.$token"
import { Route as AuthenticatedAdminRouteImport } from "./routes/_authenticated/admin"
import { Route as AuthenticatedAccountRouteImport } from "./routes/_authenticated/account"
import { Route as AuthenticatedSplatRouteImport } from "./routes/_authenticated/$"
import { Route as AuthenticatedWhatsNewIndexRouteImport } from "./routes/_authenticated/whats-new/index"
import { Route as AuthenticatedSitesIndexRouteImport } from "./routes/_authenticated/sites/index"
import { Route as AuthenticatedReimbursementsIndexRouteImport } from "./routes/_authenticated/reimbursements/index"
import { Route as AuthenticatedProjectsIndexRouteImport } from "./routes/_authenticated/projects/index"
import { Route as AuthenticatedPhotoReportTemplatesIndexRouteImport } from "./routes/_authenticated/photo-report-templates/index"
import { Route as AuthenticatedLearningIndexRouteImport } from "./routes/_authenticated/learning/index"
import { Route as AuthenticatedJournalEntriesIndexRouteImport } from "./routes/_authenticated/journal-entries/index"
import { Route as AuthenticatedJobsIndexRouteImport } from "./routes/_authenticated/jobs/index"
import { Route as AuthenticatedInboxIndexRouteImport } from "./routes/_authenticated/inbox/index"
import { Route as AuthenticatedClientsIndexRouteImport } from "./routes/_authenticated/clients/index"
import { Route as AuthenticatedAdvancesIndexRouteImport } from "./routes/_authenticated/advances/index"
import { Route as AuthenticatedAdminIndexRouteImport } from "./routes/_authenticated/admin/index"
import { Route as AuthenticatedAccountIndexRouteImport } from "./routes/_authenticated/account/index"
import { Route as AuthenticatedSitesNewRouteImport } from "./routes/_authenticated/sites/new"
import { Route as AuthenticatedSitesSiteIdRouteImport } from "./routes/_authenticated/sites/$siteId"
import { Route as AuthenticatedReimbursementsNewRouteImport } from "./routes/_authenticated/reimbursements/new"
import { Route as AuthenticatedReimbursementsLedgerRouteImport } from "./routes/_authenticated/reimbursements/ledger"
import { Route as AuthenticatedReimbursementsReimbursementIdRouteImport } from "./routes/_authenticated/reimbursements/$reimbursementId"
import { Route as AuthenticatedProjectsNewRouteImport } from "./routes/_authenticated/projects/new"
import { Route as AuthenticatedProjectsProjectIdRouteImport } from "./routes/_authenticated/projects/$projectId"
import { Route as AuthenticatedLearningModuleIdRouteImport } from "./routes/_authenticated/learning/$moduleId"
import { Route as AuthenticatedJobsNewRouteImport } from "./routes/_authenticated/jobs/new"
import { Route as AuthenticatedJobsJobIdRouteImport } from "./routes/_authenticated/jobs/$jobId"
import { Route as AuthenticatedClientsNewRouteImport } from "./routes/_authenticated/clients/new"
import { Route as AuthenticatedClientsClientIdRouteImport } from "./routes/_authenticated/clients/$clientId"
import { Route as AuthenticatedAdvancesNewRouteImport } from "./routes/_authenticated/advances/new"
import { Route as AuthenticatedAdvancesLedgerRouteImport } from "./routes/_authenticated/advances/ledger"
import { Route as AuthenticatedAdvancesAdvanceIdRouteImport } from "./routes/_authenticated/advances/$advanceId"
import { Route as AuthenticatedAccountUsersRouteImport } from "./routes/_authenticated/account/users"
import { Route as AuthenticatedAccountSessionsRouteImport } from "./routes/_authenticated/account/sessions"
import { Route as AuthenticatedAccountProfileRouteImport } from "./routes/_authenticated/account/profile"
import { Route as AuthenticatedAccountPasswordRouteImport } from "./routes/_authenticated/account/password"
import { Route as AuthenticatedAdminVisitorsIndexRouteImport } from "./routes/_authenticated/admin/visitors/index"
import { Route as AuthenticatedAdminUsersIndexRouteImport } from "./routes/_authenticated/admin/users/index"
import { Route as AuthenticatedAdminRolesIndexRouteImport } from "./routes/_authenticated/admin/roles/index"
import { Route as AuthenticatedAdminOrganizationsIndexRouteImport } from "./routes/_authenticated/admin/organizations/index"
import { Route as AuthenticatedAdminOrganizationProfileIndexRouteImport } from "./routes/_authenticated/admin/organization-profile/index"
import { Route as AuthenticatedAdminAuditLogIndexRouteImport } from "./routes/_authenticated/admin/audit-log/index"
import { Route as AuthenticatedAdminApprovalChainsIndexRouteImport } from "./routes/_authenticated/admin/approval-chains/index"
import { Route as AuthenticatedSitesSiteIdEditRouteImport } from "./routes/_authenticated/sites/$siteId_.edit"
import { Route as AuthenticatedReimbursementsReimbursementIdEditRouteImport } from "./routes/_authenticated/reimbursements/$reimbursementId_.edit"
import { Route as AuthenticatedProjectsProjectIdEditRouteImport } from "./routes/_authenticated/projects/$projectId_.edit"
import { Route as AuthenticatedLearningModuleIdProgressRouteImport } from "./routes/_authenticated/learning/$moduleId_.progress"
import { Route as AuthenticatedJobsJobIdEditRouteImport } from "./routes/_authenticated/jobs/$jobId_.edit"
import { Route as AuthenticatedClientsClientIdEditRouteImport } from "./routes/_authenticated/clients/$clientId_.edit"
import { Route as AuthenticatedAdvancesAdvanceIdEditRouteImport } from "./routes/_authenticated/advances/$advanceId_.edit"
import { Route as AuthenticatedAdminVisitorsGroupIdRouteImport } from "./routes/_authenticated/admin/visitors/$groupId"
import { Route as AuthenticatedAdminUsersNewRouteImport } from "./routes/_authenticated/admin/users/new"
import { Route as AuthenticatedAdminUsersUserIdRouteImport } from "./routes/_authenticated/admin/users/$userId"
import { Route as AuthenticatedAdminSettingsVehiclesIndexRouteImport } from "./routes/_authenticated/admin/settings/vehicles/index"
import { Route as AuthenticatedAdminSettingsServiceTypesIndexRouteImport } from "./routes/_authenticated/admin/settings/service-types/index"
import { Route as AuthenticatedAdminSettingsReceiptWindowIndexRouteImport } from "./routes/_authenticated/admin/settings/receipt-window/index"
import { Route as AuthenticatedAdminSettingsProjectTypesIndexRouteImport } from "./routes/_authenticated/admin/settings/project-types/index"
import { Route as AuthenticatedAdminSettingsMileageRatesIndexRouteImport } from "./routes/_authenticated/admin/settings/mileage-rates/index"
import { Route as AuthenticatedAdminSettingsExpenseCategoriesIndexRouteImport } from "./routes/_authenticated/admin/settings/expense-categories/index"
import { Route as AuthenticatedAdminSettingsAccountMappingIndexRouteImport } from "./routes/_authenticated/admin/settings/account-mapping/index"
import { Route as AuthenticatedAdminSettingsAccountCodesIndexRouteImport } from "./routes/_authenticated/admin/settings/account-codes/index"

const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: "/reset-password",
  path: "/reset-password",
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: "/forgot-password",
  path: "/forgot-password",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: "/_authenticated",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const ReportTokenRoute = ReportTokenRouteImport.update({
  id: "/report/$token",
  path: "/report/$token",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
  id: "/admin",
  path: "/admin",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAccountRoute = AuthenticatedAccountRouteImport.update({
  id: "/account",
  path: "/account",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSplatRoute = AuthenticatedSplatRouteImport.update({
  id: "/$",
  path: "/$",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedWhatsNewIndexRoute =
  AuthenticatedWhatsNewIndexRouteImport.update({
    id: "/whats-new/",
    path: "/whats-new/",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSitesIndexRoute = AuthenticatedSitesIndexRouteImport.update({
  id: "/sites/",
  path: "/sites/",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedReimbursementsIndexRoute =
  AuthenticatedReimbursementsIndexRouteImport.update({
    id: "/reimbursements/",
    path: "/reimbursements/",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProjectsIndexRoute =
  AuthenticatedProjectsIndexRouteImport.update({
    id: "/projects/",
    path: "/projects/",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPhotoReportTemplatesIndexRoute =
  AuthenticatedPhotoReportTemplatesIndexRouteImport.update({
    id: "/photo-report-templates/",
    path: "/photo-report-templates/",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLearningIndexRoute =
  AuthenticatedLearningIndexRouteImport.update({
    id: "/learning/",
    path: "/learning/",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedJournalEntriesIndexRoute =
  AuthenticatedJournalEntriesIndexRouteImport.update({
    id: "/journal-entries/",
    path: "/journal-entries/",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedJobsIndexRoute = AuthenticatedJobsIndexRouteImport.update({
  id: "/jobs/",
  path: "/jobs/",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedInboxIndexRoute = AuthenticatedInboxIndexRouteImport.update({
  id: "/inbox/",
  path: "/inbox/",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedClientsIndexRoute =
  AuthenticatedClientsIndexRouteImport.update({
    id: "/clients/",
    path: "/clients/",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdvancesIndexRoute =
  AuthenticatedAdvancesIndexRouteImport.update({
    id: "/advances/",
    path: "/advances/",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AuthenticatedAdminRoute,
} as any)
const AuthenticatedAccountIndexRoute =
  AuthenticatedAccountIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => AuthenticatedAccountRoute,
  } as any)
const AuthenticatedSitesNewRoute = AuthenticatedSitesNewRouteImport.update({
  id: "/sites/new",
  path: "/sites/new",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSitesSiteIdRoute =
  AuthenticatedSitesSiteIdRouteImport.update({
    id: "/sites/$siteId",
    path: "/sites/$siteId",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedReimbursementsNewRoute =
  AuthenticatedReimbursementsNewRouteImport.update({
    id: "/reimbursements/new",
    path: "/reimbursements/new",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedReimbursementsLedgerRoute =
  AuthenticatedReimbursementsLedgerRouteImport.update({
    id: "/reimbursements/ledger",
    path: "/reimbursements/ledger",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedReimbursementsReimbursementIdRoute =
  AuthenticatedReimbursementsReimbursementIdRouteImport.update({
    id: "/reimbursements/$reimbursementId",
    path: "/reimbursements/$reimbursementId",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProjectsNewRoute =
  AuthenticatedProjectsNewRouteImport.update({
    id: "/projects/new",
    path: "/projects/new",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProjectsProjectIdRoute =
  AuthenticatedProjectsProjectIdRouteImport.update({
    id: "/projects/$projectId",
    path: "/projects/$projectId",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLearningModuleIdRoute =
  AuthenticatedLearningModuleIdRouteImport.update({
    id: "/learning/$moduleId",
    path: "/learning/$moduleId",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedJobsNewRoute = AuthenticatedJobsNewRouteImport.update({
  id: "/jobs/new",
  path: "/jobs/new",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedJobsJobIdRoute = AuthenticatedJobsJobIdRouteImport.update({
  id: "/jobs/$jobId",
  path: "/jobs/$jobId",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedClientsNewRoute = AuthenticatedClientsNewRouteImport.update({
  id: "/clients/new",
  path: "/clients/new",
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedClientsClientIdRoute =
  AuthenticatedClientsClientIdRouteImport.update({
    id: "/clients/$clientId",
    path: "/clients/$clientId",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdvancesNewRoute =
  AuthenticatedAdvancesNewRouteImport.update({
    id: "/advances/new",
    path: "/advances/new",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdvancesLedgerRoute =
  AuthenticatedAdvancesLedgerRouteImport.update({
    id: "/advances/ledger",
    path: "/advances/ledger",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdvancesAdvanceIdRoute =
  AuthenticatedAdvancesAdvanceIdRouteImport.update({
    id: "/advances/$advanceId",
    path: "/advances/$advanceId",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAccountUsersRoute =
  AuthenticatedAccountUsersRouteImport.update({
    id: "/users",
    path: "/users",
    getParentRoute: () => AuthenticatedAccountRoute,
  } as any)
const AuthenticatedAccountSessionsRoute =
  AuthenticatedAccountSessionsRouteImport.update({
    id: "/sessions",
    path: "/sessions",
    getParentRoute: () => AuthenticatedAccountRoute,
  } as any)
const AuthenticatedAccountProfileRoute =
  AuthenticatedAccountProfileRouteImport.update({
    id: "/profile",
    path: "/profile",
    getParentRoute: () => AuthenticatedAccountRoute,
  } as any)
const AuthenticatedAccountPasswordRoute =
  AuthenticatedAccountPasswordRouteImport.update({
    id: "/password",
    path: "/password",
    getParentRoute: () => AuthenticatedAccountRoute,
  } as any)
const AuthenticatedAdminVisitorsIndexRoute =
  AuthenticatedAdminVisitorsIndexRouteImport.update({
    id: "/visitors/",
    path: "/visitors/",
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminUsersIndexRoute =
  AuthenticatedAdminUsersIndexRouteImport.update({
    id: "/users/",
    path: "/users/",
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminRolesIndexRoute =
  AuthenticatedAdminRolesIndexRouteImport.update({
    id: "/roles/",
    path: "/roles/",
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminOrganizationsIndexRoute =
  AuthenticatedAdminOrganizationsIndexRouteImport.update({
    id: "/organizations/",
    path: "/organizations/",
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminOrganizationProfileIndexRoute =
  AuthenticatedAdminOrganizationProfileIndexRouteImport.update({
    id: "/organization-profile/",
    path: "/organization-profile/",
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminAuditLogIndexRoute =
  AuthenticatedAdminAuditLogIndexRouteImport.update({
    id: "/audit-log/",
    path: "/audit-log/",
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminApprovalChainsIndexRoute =
  AuthenticatedAdminApprovalChainsIndexRouteImport.update({
    id: "/approval-chains/",
    path: "/approval-chains/",
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedSitesSiteIdEditRoute =
  AuthenticatedSitesSiteIdEditRouteImport.update({
    id: "/sites/$siteId_/edit",
    path: "/sites/$siteId/edit",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedReimbursementsReimbursementIdEditRoute =
  AuthenticatedReimbursementsReimbursementIdEditRouteImport.update({
    id: "/reimbursements/$reimbursementId_/edit",
    path: "/reimbursements/$reimbursementId/edit",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProjectsProjectIdEditRoute =
  AuthenticatedProjectsProjectIdEditRouteImport.update({
    id: "/projects/$projectId_/edit",
    path: "/projects/$projectId/edit",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLearningModuleIdProgressRoute =
  AuthenticatedLearningModuleIdProgressRouteImport.update({
    id: "/learning/$moduleId_/progress",
    path: "/learning/$moduleId/progress",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedJobsJobIdEditRoute =
  AuthenticatedJobsJobIdEditRouteImport.update({
    id: "/jobs/$jobId_/edit",
    path: "/jobs/$jobId/edit",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedClientsClientIdEditRoute =
  AuthenticatedClientsClientIdEditRouteImport.update({
    id: "/clients/$clientId_/edit",
    path: "/clients/$clientId/edit",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdvancesAdvanceIdEditRoute =
  AuthenticatedAdvancesAdvanceIdEditRouteImport.update({
    id: "/advances/$advanceId_/edit",
    path: "/advances/$advanceId/edit",
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminVisitorsGroupIdRoute =
  AuthenticatedAdminVisitorsGroupIdRouteImport.update({
    id: "/visitors/$groupId",
    path: "/visitors/$groupId",
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminUsersNewRoute =
  AuthenticatedAdminUsersNewRouteImport.update({
    id: "/users/new",
    path: "/users/new",
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminUsersUserIdRoute =
  AuthenticatedAdminUsersUserIdRouteImport.update({
    id: "/users/$userId",
    path: "/users/$userId",
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminSettingsVehiclesIndexRoute =
  AuthenticatedAdminSettingsVehiclesIndexRouteImport.update({
    id: "/settings/vehicles/",
    path: "/settings/vehicles/",
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminSettingsServiceTypesIndexRoute =
  AuthenticatedAdminSettingsServiceTypesIndexRouteImport.update({
    id: "/settings/service-types/",
    path: "/settings/service-types/",
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminSettingsReceiptWindowIndexRoute =
  AuthenticatedAdminSettingsReceiptWindowIndexRouteImport.update({
    id: "/settings/receipt-window/",
    path: "/settings/receipt-window/",
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminSettingsProjectTypesIndexRoute =
  AuthenticatedAdminSettingsProjectTypesIndexRouteImport.update({
    id: "/settings/project-types/",
    path: "/settings/project-types/",
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminSettingsMileageRatesIndexRoute =
  AuthenticatedAdminSettingsMileageRatesIndexRouteImport.update({
    id: "/settings/mileage-rates/",
    path: "/settings/mileage-rates/",
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminSettingsExpenseCategoriesIndexRoute =
  AuthenticatedAdminSettingsExpenseCategoriesIndexRouteImport.update({
    id: "/settings/expense-categories/",
    path: "/settings/expense-categories/",
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminSettingsAccountMappingIndexRoute =
  AuthenticatedAdminSettingsAccountMappingIndexRouteImport.update({
    id: "/settings/account-mapping/",
    path: "/settings/account-mapping/",
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminSettingsAccountCodesIndexRoute =
  AuthenticatedAdminSettingsAccountCodesIndexRouteImport.update({
    id: "/settings/account-codes/",
    path: "/settings/account-codes/",
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)

export interface FileRoutesByFullPath {
  "/": typeof AuthenticatedIndexRoute
  "/forgot-password": typeof ForgotPasswordRoute
  "/login": typeof LoginRoute
  "/reset-password": typeof ResetPasswordRoute
  "/$": typeof AuthenticatedSplatRoute
  "/account": typeof AuthenticatedAccountRouteWithChildren
  "/admin": typeof AuthenticatedAdminRouteWithChildren
  "/report/$token": typeof ReportTokenRoute
  "/account/password": typeof AuthenticatedAccountPasswordRoute
  "/account/profile": typeof AuthenticatedAccountProfileRoute
  "/account/sessions": typeof AuthenticatedAccountSessionsRoute
  "/account/users": typeof AuthenticatedAccountUsersRoute
  "/advances/$advanceId": typeof AuthenticatedAdvancesAdvanceIdRoute
  "/advances/ledger": typeof AuthenticatedAdvancesLedgerRoute
  "/advances/new": typeof AuthenticatedAdvancesNewRoute
  "/clients/$clientId": typeof AuthenticatedClientsClientIdRoute
  "/clients/new": typeof AuthenticatedClientsNewRoute
  "/jobs/$jobId": typeof AuthenticatedJobsJobIdRoute
  "/jobs/new": typeof AuthenticatedJobsNewRoute
  "/learning/$moduleId": typeof AuthenticatedLearningModuleIdRoute
  "/projects/$projectId": typeof AuthenticatedProjectsProjectIdRoute
  "/projects/new": typeof AuthenticatedProjectsNewRoute
  "/reimbursements/$reimbursementId": typeof AuthenticatedReimbursementsReimbursementIdRoute
  "/reimbursements/ledger": typeof AuthenticatedReimbursementsLedgerRoute
  "/reimbursements/new": typeof AuthenticatedReimbursementsNewRoute
  "/sites/$siteId": typeof AuthenticatedSitesSiteIdRoute
  "/sites/new": typeof AuthenticatedSitesNewRoute
  "/account/": typeof AuthenticatedAccountIndexRoute
  "/admin/": typeof AuthenticatedAdminIndexRoute
  "/advances/": typeof AuthenticatedAdvancesIndexRoute
  "/clients/": typeof AuthenticatedClientsIndexRoute
  "/inbox/": typeof AuthenticatedInboxIndexRoute
  "/jobs/": typeof AuthenticatedJobsIndexRoute
  "/journal-entries/": typeof AuthenticatedJournalEntriesIndexRoute
  "/learning/": typeof AuthenticatedLearningIndexRoute
  "/photo-report-templates/": typeof AuthenticatedPhotoReportTemplatesIndexRoute
  "/projects/": typeof AuthenticatedProjectsIndexRoute
  "/reimbursements/": typeof AuthenticatedReimbursementsIndexRoute
  "/sites/": typeof AuthenticatedSitesIndexRoute
  "/whats-new/": typeof AuthenticatedWhatsNewIndexRoute
  "/admin/users/$userId": typeof AuthenticatedAdminUsersUserIdRoute
  "/admin/users/new": typeof AuthenticatedAdminUsersNewRoute
  "/admin/visitors/$groupId": typeof AuthenticatedAdminVisitorsGroupIdRoute
  "/advances/$advanceId/edit": typeof AuthenticatedAdvancesAdvanceIdEditRoute
  "/clients/$clientId/edit": typeof AuthenticatedClientsClientIdEditRoute
  "/jobs/$jobId/edit": typeof AuthenticatedJobsJobIdEditRoute
  "/learning/$moduleId/progress": typeof AuthenticatedLearningModuleIdProgressRoute
  "/projects/$projectId/edit": typeof AuthenticatedProjectsProjectIdEditRoute
  "/reimbursements/$reimbursementId/edit": typeof AuthenticatedReimbursementsReimbursementIdEditRoute
  "/sites/$siteId/edit": typeof AuthenticatedSitesSiteIdEditRoute
  "/admin/approval-chains/": typeof AuthenticatedAdminApprovalChainsIndexRoute
  "/admin/audit-log/": typeof AuthenticatedAdminAuditLogIndexRoute
  "/admin/organization-profile/": typeof AuthenticatedAdminOrganizationProfileIndexRoute
  "/admin/organizations/": typeof AuthenticatedAdminOrganizationsIndexRoute
  "/admin/roles/": typeof AuthenticatedAdminRolesIndexRoute
  "/admin/users/": typeof AuthenticatedAdminUsersIndexRoute
  "/admin/visitors/": typeof AuthenticatedAdminVisitorsIndexRoute
  "/admin/settings/account-codes/": typeof AuthenticatedAdminSettingsAccountCodesIndexRoute
  "/admin/settings/account-mapping/": typeof AuthenticatedAdminSettingsAccountMappingIndexRoute
  "/admin/settings/expense-categories/": typeof AuthenticatedAdminSettingsExpenseCategoriesIndexRoute
  "/admin/settings/mileage-rates/": typeof AuthenticatedAdminSettingsMileageRatesIndexRoute
  "/admin/settings/project-types/": typeof AuthenticatedAdminSettingsProjectTypesIndexRoute
  "/admin/settings/receipt-window/": typeof AuthenticatedAdminSettingsReceiptWindowIndexRoute
  "/admin/settings/service-types/": typeof AuthenticatedAdminSettingsServiceTypesIndexRoute
  "/admin/settings/vehicles/": typeof AuthenticatedAdminSettingsVehiclesIndexRoute
}
export interface FileRoutesByTo {
  "/forgot-password": typeof ForgotPasswordRoute
  "/login": typeof LoginRoute
  "/reset-password": typeof ResetPasswordRoute
  "/$": typeof AuthenticatedSplatRoute
  "/report/$token": typeof ReportTokenRoute
  "/": typeof AuthenticatedIndexRoute
  "/account/password": typeof AuthenticatedAccountPasswordRoute
  "/account/profile": typeof AuthenticatedAccountProfileRoute
  "/account/sessions": typeof AuthenticatedAccountSessionsRoute
  "/account/users": typeof AuthenticatedAccountUsersRoute
  "/advances/$advanceId": typeof AuthenticatedAdvancesAdvanceIdRoute
  "/advances/ledger": typeof AuthenticatedAdvancesLedgerRoute
  "/advances/new": typeof AuthenticatedAdvancesNewRoute
  "/clients/$clientId": typeof AuthenticatedClientsClientIdRoute
  "/clients/new": typeof AuthenticatedClientsNewRoute
  "/jobs/$jobId": typeof AuthenticatedJobsJobIdRoute
  "/jobs/new": typeof AuthenticatedJobsNewRoute
  "/learning/$moduleId": typeof AuthenticatedLearningModuleIdRoute
  "/projects/$projectId": typeof AuthenticatedProjectsProjectIdRoute
  "/projects/new": typeof AuthenticatedProjectsNewRoute
  "/reimbursements/$reimbursementId": typeof AuthenticatedReimbursementsReimbursementIdRoute
  "/reimbursements/ledger": typeof AuthenticatedReimbursementsLedgerRoute
  "/reimbursements/new": typeof AuthenticatedReimbursementsNewRoute
  "/sites/$siteId": typeof AuthenticatedSitesSiteIdRoute
  "/sites/new": typeof AuthenticatedSitesNewRoute
  "/account": typeof AuthenticatedAccountIndexRoute
  "/admin": typeof AuthenticatedAdminIndexRoute
  "/advances": typeof AuthenticatedAdvancesIndexRoute
  "/clients": typeof AuthenticatedClientsIndexRoute
  "/inbox": typeof AuthenticatedInboxIndexRoute
  "/jobs": typeof AuthenticatedJobsIndexRoute
  "/journal-entries": typeof AuthenticatedJournalEntriesIndexRoute
  "/learning": typeof AuthenticatedLearningIndexRoute
  "/photo-report-templates": typeof AuthenticatedPhotoReportTemplatesIndexRoute
  "/projects": typeof AuthenticatedProjectsIndexRoute
  "/reimbursements": typeof AuthenticatedReimbursementsIndexRoute
  "/sites": typeof AuthenticatedSitesIndexRoute
  "/whats-new": typeof AuthenticatedWhatsNewIndexRoute
  "/admin/users/$userId": typeof AuthenticatedAdminUsersUserIdRoute
  "/admin/users/new": typeof AuthenticatedAdminUsersNewRoute
  "/admin/visitors/$groupId": typeof AuthenticatedAdminVisitorsGroupIdRoute
  "/advances/$advanceId/edit": typeof AuthenticatedAdvancesAdvanceIdEditRoute
  "/clients/$clientId/edit": typeof AuthenticatedClientsClientIdEditRoute
  "/jobs/$jobId/edit": typeof AuthenticatedJobsJobIdEditRoute
  "/learning/$moduleId/progress": typeof AuthenticatedLearningModuleIdProgressRoute
  "/projects/$projectId/edit": typeof AuthenticatedProjectsProjectIdEditRoute
  "/reimbursements/$reimbursementId/edit": typeof AuthenticatedReimbursementsReimbursementIdEditRoute
  "/sites/$siteId/edit": typeof AuthenticatedSitesSiteIdEditRoute
  "/admin/approval-chains": typeof AuthenticatedAdminApprovalChainsIndexRoute
  "/admin/audit-log": typeof AuthenticatedAdminAuditLogIndexRoute
  "/admin/organization-profile": typeof AuthenticatedAdminOrganizationProfileIndexRoute
  "/admin/organizations": typeof AuthenticatedAdminOrganizationsIndexRoute
  "/admin/roles": typeof AuthenticatedAdminRolesIndexRoute
  "/admin/users": typeof AuthenticatedAdminUsersIndexRoute
  "/admin/visitors": typeof AuthenticatedAdminVisitorsIndexRoute
  "/admin/settings/account-codes": typeof AuthenticatedAdminSettingsAccountCodesIndexRoute
  "/admin/settings/account-mapping": typeof AuthenticatedAdminSettingsAccountMappingIndexRoute
  "/admin/settings/expense-categories": typeof AuthenticatedAdminSettingsExpenseCategoriesIndexRoute
  "/admin/settings/mileage-rates": typeof AuthenticatedAdminSettingsMileageRatesIndexRoute
  "/admin/settings/project-types": typeof AuthenticatedAdminSettingsProjectTypesIndexRoute
  "/admin/settings/receipt-window": typeof AuthenticatedAdminSettingsReceiptWindowIndexRoute
  "/admin/settings/service-types": typeof AuthenticatedAdminSettingsServiceTypesIndexRoute
  "/admin/settings/vehicles": typeof AuthenticatedAdminSettingsVehiclesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/_authenticated": typeof AuthenticatedRouteWithChildren
  "/forgot-password": typeof ForgotPasswordRoute
  "/login": typeof LoginRoute
  "/reset-password": typeof ResetPasswordRoute
  "/_authenticated/$": typeof AuthenticatedSplatRoute
  "/_authenticated/account": typeof AuthenticatedAccountRouteWithChildren
  "/_authenticated/admin": typeof AuthenticatedAdminRouteWithChildren
  "/report/$token": typeof ReportTokenRoute
  "/_authenticated/": typeof AuthenticatedIndexRoute
  "/_authenticated/account/password": typeof AuthenticatedAccountPasswordRoute
  "/_authenticated/account/profile": typeof AuthenticatedAccountProfileRoute
  "/_authenticated/account/sessions": typeof AuthenticatedAccountSessionsRoute
  "/_authenticated/account/users": typeof AuthenticatedAccountUsersRoute
  "/_authenticated/advances/$advanceId": typeof AuthenticatedAdvancesAdvanceIdRoute
  "/_authenticated/advances/ledger": typeof AuthenticatedAdvancesLedgerRoute
  "/_authenticated/advances/new": typeof AuthenticatedAdvancesNewRoute
  "/_authenticated/clients/$clientId": typeof AuthenticatedClientsClientIdRoute
  "/_authenticated/clients/new": typeof AuthenticatedClientsNewRoute
  "/_authenticated/jobs/$jobId": typeof AuthenticatedJobsJobIdRoute
  "/_authenticated/jobs/new": typeof AuthenticatedJobsNewRoute
  "/_authenticated/learning/$moduleId": typeof AuthenticatedLearningModuleIdRoute
  "/_authenticated/projects/$projectId": typeof AuthenticatedProjectsProjectIdRoute
  "/_authenticated/projects/new": typeof AuthenticatedProjectsNewRoute
  "/_authenticated/reimbursements/$reimbursementId": typeof AuthenticatedReimbursementsReimbursementIdRoute
  "/_authenticated/reimbursements/ledger": typeof AuthenticatedReimbursementsLedgerRoute
  "/_authenticated/reimbursements/new": typeof AuthenticatedReimbursementsNewRoute
  "/_authenticated/sites/$siteId": typeof AuthenticatedSitesSiteIdRoute
  "/_authenticated/sites/new": typeof AuthenticatedSitesNewRoute
  "/_authenticated/account/": typeof AuthenticatedAccountIndexRoute
  "/_authenticated/admin/": typeof AuthenticatedAdminIndexRoute
  "/_authenticated/advances/": typeof AuthenticatedAdvancesIndexRoute
  "/_authenticated/clients/": typeof AuthenticatedClientsIndexRoute
  "/_authenticated/inbox/": typeof AuthenticatedInboxIndexRoute
  "/_authenticated/jobs/": typeof AuthenticatedJobsIndexRoute
  "/_authenticated/journal-entries/": typeof AuthenticatedJournalEntriesIndexRoute
  "/_authenticated/learning/": typeof AuthenticatedLearningIndexRoute
  "/_authenticated/photo-report-templates/": typeof AuthenticatedPhotoReportTemplatesIndexRoute
  "/_authenticated/projects/": typeof AuthenticatedProjectsIndexRoute
  "/_authenticated/reimbursements/": typeof AuthenticatedReimbursementsIndexRoute
  "/_authenticated/sites/": typeof AuthenticatedSitesIndexRoute
  "/_authenticated/whats-new/": typeof AuthenticatedWhatsNewIndexRoute
  "/_authenticated/admin/users/$userId": typeof AuthenticatedAdminUsersUserIdRoute
  "/_authenticated/admin/users/new": typeof AuthenticatedAdminUsersNewRoute
  "/_authenticated/admin/visitors/$groupId": typeof AuthenticatedAdminVisitorsGroupIdRoute
  "/_authenticated/advances/$advanceId_/edit": typeof AuthenticatedAdvancesAdvanceIdEditRoute
  "/_authenticated/clients/$clientId_/edit": typeof AuthenticatedClientsClientIdEditRoute
  "/_authenticated/jobs/$jobId_/edit": typeof AuthenticatedJobsJobIdEditRoute
  "/_authenticated/learning/$moduleId_/progress": typeof AuthenticatedLearningModuleIdProgressRoute
  "/_authenticated/projects/$projectId_/edit": typeof AuthenticatedProjectsProjectIdEditRoute
  "/_authenticated/reimbursements/$reimbursementId_/edit": typeof AuthenticatedReimbursementsReimbursementIdEditRoute
  "/_authenticated/sites/$siteId_/edit": typeof AuthenticatedSitesSiteIdEditRoute
  "/_authenticated/admin/approval-chains/": typeof AuthenticatedAdminApprovalChainsIndexRoute
  "/_authenticated/admin/audit-log/": typeof AuthenticatedAdminAuditLogIndexRoute
  "/_authenticated/admin/organization-profile/": typeof AuthenticatedAdminOrganizationProfileIndexRoute
  "/_authenticated/admin/organizations/": typeof AuthenticatedAdminOrganizationsIndexRoute
  "/_authenticated/admin/roles/": typeof AuthenticatedAdminRolesIndexRoute
  "/_authenticated/admin/users/": typeof AuthenticatedAdminUsersIndexRoute
  "/_authenticated/admin/visitors/": typeof AuthenticatedAdminVisitorsIndexRoute
  "/_authenticated/admin/settings/account-codes/": typeof AuthenticatedAdminSettingsAccountCodesIndexRoute
  "/_authenticated/admin/settings/account-mapping/": typeof AuthenticatedAdminSettingsAccountMappingIndexRoute
  "/_authenticated/admin/settings/expense-categories/": typeof AuthenticatedAdminSettingsExpenseCategoriesIndexRoute
  "/_authenticated/admin/settings/mileage-rates/": typeof AuthenticatedAdminSettingsMileageRatesIndexRoute
  "/_authenticated/admin/settings/project-types/": typeof AuthenticatedAdminSettingsProjectTypesIndexRoute
  "/_authenticated/admin/settings/receipt-window/": typeof AuthenticatedAdminSettingsReceiptWindowIndexRoute
  "/_authenticated/admin/settings/service-types/": typeof AuthenticatedAdminSettingsServiceTypesIndexRoute
  "/_authenticated/admin/settings/vehicles/": typeof AuthenticatedAdminSettingsVehiclesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/forgot-password"
    | "/login"
    | "/reset-password"
    | "/$"
    | "/account"
    | "/admin"
    | "/report/$token"
    | "/account/password"
    | "/account/profile"
    | "/account/sessions"
    | "/account/users"
    | "/advances/$advanceId"
    | "/advances/ledger"
    | "/advances/new"
    | "/clients/$clientId"
    | "/clients/new"
    | "/jobs/$jobId"
    | "/jobs/new"
    | "/learning/$moduleId"
    | "/projects/$projectId"
    | "/projects/new"
    | "/reimbursements/$reimbursementId"
    | "/reimbursements/ledger"
    | "/reimbursements/new"
    | "/sites/$siteId"
    | "/sites/new"
    | "/account/"
    | "/admin/"
    | "/advances/"
    | "/clients/"
    | "/inbox/"
    | "/jobs/"
    | "/journal-entries/"
    | "/learning/"
    | "/photo-report-templates/"
    | "/projects/"
    | "/reimbursements/"
    | "/sites/"
    | "/whats-new/"
    | "/admin/users/$userId"
    | "/admin/users/new"
    | "/admin/visitors/$groupId"
    | "/advances/$advanceId/edit"
    | "/clients/$clientId/edit"
    | "/jobs/$jobId/edit"
    | "/learning/$moduleId/progress"
    | "/projects/$projectId/edit"
    | "/reimbursements/$reimbursementId/edit"
    | "/sites/$siteId/edit"
    | "/admin/approval-chains/"
    | "/admin/audit-log/"
    | "/admin/organization-profile/"
    | "/admin/organizations/"
    | "/admin/roles/"
    | "/admin/users/"
    | "/admin/visitors/"
    | "/admin/settings/account-codes/"
    | "/admin/settings/account-mapping/"
    | "/admin/settings/expense-categories/"
    | "/admin/settings/mileage-rates/"
    | "/admin/settings/project-types/"
    | "/admin/settings/receipt-window/"
    | "/admin/settings/service-types/"
    | "/admin/settings/vehicles/"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/forgot-password"
    | "/login"
    | "/reset-password"
    | "/$"
    | "/report/$token"
    | "/"
    | "/account/password"
    | "/account/profile"
    | "/account/sessions"
    | "/account/users"
    | "/advances/$advanceId"
    | "/advances/ledger"
    | "/advances/new"
    | "/clients/$clientId"
    | "/clients/new"
    | "/jobs/$jobId"
    | "/jobs/new"
    | "/learning/$moduleId"
    | "/projects/$projectId"
    | "/projects/new"
    | "/reimbursements/$reimbursementId"
    | "/reimbursements/ledger"
    | "/reimbursements/new"
    | "/sites/$siteId"
    | "/sites/new"
    | "/account"
    | "/admin"
    | "/advances"
    | "/clients"
    | "/inbox"
    | "/jobs"
    | "/journal-entries"
    | "/learning"
    | "/photo-report-templates"
    | "/projects"
    | "/reimbursements"
    | "/sites"
    | "/whats-new"
    | "/admin/users/$userId"
    | "/admin/users/new"
    | "/admin/visitors/$groupId"
    | "/advances/$advanceId/edit"
    | "/clients/$clientId/edit"
    | "/jobs/$jobId/edit"
    | "/learning/$moduleId/progress"
    | "/projects/$projectId/edit"
    | "/reimbursements/$reimbursementId/edit"
    | "/sites/$siteId/edit"
    | "/admin/approval-chains"
    | "/admin/audit-log"
    | "/admin/organization-profile"
    | "/admin/organizations"
    | "/admin/roles"
    | "/admin/users"
    | "/admin/visitors"
    | "/admin/settings/account-codes"
    | "/admin/settings/account-mapping"
    | "/admin/settings/expense-categories"
    | "/admin/settings/mileage-rates"
    | "/admin/settings/project-types"
    | "/admin/settings/receipt-window"
    | "/admin/settings/service-types"
    | "/admin/settings/vehicles"
  id:
    | "__root__"
    | "/_authenticated"
    | "/forgot-password"
    | "/login"
    | "/reset-password"
    | "/_authenticated/$"
    | "/_authenticated/account"
    | "/_authenticated/admin"
    | "/report/$token"
    | "/_authenticated/"
    | "/_authenticated/account/password"
    | "/_authenticated/account/profile"
    | "/_authenticated/account/sessions"
    | "/_authenticated/account/users"
    | "/_authenticated/advances/$advanceId"
    | "/_authenticated/advances/ledger"
    | "/_authenticated/advances/new"
    | "/_authenticated/clients/$clientId"
    | "/_authenticated/clients/new"
    | "/_authenticated/jobs/$jobId"
    | "/_authenticated/jobs/new"
    | "/_authenticated/learning/$moduleId"
    | "/_authenticated/projects/$projectId"
    | "/_authenticated/projects/new"
    | "/_authenticated/reimbursements/$reimbursementId"
    | "/_authenticated/reimbursements/ledger"
    | "/_authenticated/reimbursements/new"
    | "/_authenticated/sites/$siteId"
    | "/_authenticated/sites/new"
    | "/_authenticated/account/"
    | "/_authenticated/admin/"
    | "/_authenticated/advances/"
    | "/_authenticated/clients/"
    | "/_authenticated/inbox/"
    | "/_authenticated/jobs/"
    | "/_authenticated/journal-entries/"
    | "/_authenticated/learning/"
    | "/_authenticated/photo-report-templates/"
    | "/_authenticated/projects/"
    | "/_authenticated/reimbursements/"
    | "/_authenticated/sites/"
    | "/_authenticated/whats-new/"
    | "/_authenticated/admin/users/$userId"
    | "/_authenticated/admin/users/new"
    | "/_authenticated/admin/visitors/$groupId"
    | "/_authenticated/advances/$advanceId_/edit"
    | "/_authenticated/clients/$clientId_/edit"
    | "/_authenticated/jobs/$jobId_/edit"
    | "/_authenticated/learning/$moduleId_/progress"
    | "/_authenticated/projects/$projectId_/edit"
    | "/_authenticated/reimbursements/$reimbursementId_/edit"
    | "/_authenticated/sites/$siteId_/edit"
    | "/_authenticated/admin/approval-chains/"
    | "/_authenticated/admin/audit-log/"
    | "/_authenticated/admin/organization-profile/"
    | "/_authenticated/admin/organizations/"
    | "/_authenticated/admin/roles/"
    | "/_authenticated/admin/users/"
    | "/_authenticated/admin/visitors/"
    | "/_authenticated/admin/settings/account-codes/"
    | "/_authenticated/admin/settings/account-mapping/"
    | "/_authenticated/admin/settings/expense-categories/"
    | "/_authenticated/admin/settings/mileage-rates/"
    | "/_authenticated/admin/settings/project-types/"
    | "/_authenticated/admin/settings/receipt-window/"
    | "/_authenticated/admin/settings/service-types/"
    | "/_authenticated/admin/settings/vehicles/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  ReportTokenRoute: typeof ReportTokenRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/reset-password": {
      id: "/reset-password"
      path: "/reset-password"
      fullPath: "/reset-password"
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/login": {
      id: "/login"
      path: "/login"
      fullPath: "/login"
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/forgot-password": {
      id: "/forgot-password"
      path: "/forgot-password"
      fullPath: "/forgot-password"
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_authenticated": {
      id: "/_authenticated"
      path: ""
      fullPath: "/"
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_authenticated/": {
      id: "/_authenticated/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/report/$token": {
      id: "/report/$token"
      path: "/report/$token"
      fullPath: "/report/$token"
      preLoaderRoute: typeof ReportTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_authenticated/admin": {
      id: "/_authenticated/admin"
      path: "/admin"
      fullPath: "/admin"
      preLoaderRoute: typeof AuthenticatedAdminRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/account": {
      id: "/_authenticated/account"
      path: "/account"
      fullPath: "/account"
      preLoaderRoute: typeof AuthenticatedAccountRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/$": {
      id: "/_authenticated/$"
      path: "/$"
      fullPath: "/$"
      preLoaderRoute: typeof AuthenticatedSplatRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/whats-new/": {
      id: "/_authenticated/whats-new/"
      path: "/whats-new"
      fullPath: "/whats-new/"
      preLoaderRoute: typeof AuthenticatedWhatsNewIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/sites/": {
      id: "/_authenticated/sites/"
      path: "/sites"
      fullPath: "/sites/"
      preLoaderRoute: typeof AuthenticatedSitesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/reimbursements/": {
      id: "/_authenticated/reimbursements/"
      path: "/reimbursements"
      fullPath: "/reimbursements/"
      preLoaderRoute: typeof AuthenticatedReimbursementsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/projects/": {
      id: "/_authenticated/projects/"
      path: "/projects"
      fullPath: "/projects/"
      preLoaderRoute: typeof AuthenticatedProjectsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/photo-report-templates/": {
      id: "/_authenticated/photo-report-templates/"
      path: "/photo-report-templates"
      fullPath: "/photo-report-templates/"
      preLoaderRoute: typeof AuthenticatedPhotoReportTemplatesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/learning/": {
      id: "/_authenticated/learning/"
      path: "/learning"
      fullPath: "/learning/"
      preLoaderRoute: typeof AuthenticatedLearningIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/journal-entries/": {
      id: "/_authenticated/journal-entries/"
      path: "/journal-entries"
      fullPath: "/journal-entries/"
      preLoaderRoute: typeof AuthenticatedJournalEntriesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/jobs/": {
      id: "/_authenticated/jobs/"
      path: "/jobs"
      fullPath: "/jobs/"
      preLoaderRoute: typeof AuthenticatedJobsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/inbox/": {
      id: "/_authenticated/inbox/"
      path: "/inbox"
      fullPath: "/inbox/"
      preLoaderRoute: typeof AuthenticatedInboxIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/clients/": {
      id: "/_authenticated/clients/"
      path: "/clients"
      fullPath: "/clients/"
      preLoaderRoute: typeof AuthenticatedClientsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/advances/": {
      id: "/_authenticated/advances/"
      path: "/advances"
      fullPath: "/advances/"
      preLoaderRoute: typeof AuthenticatedAdvancesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/admin/": {
      id: "/_authenticated/admin/"
      path: "/"
      fullPath: "/admin/"
      preLoaderRoute: typeof AuthenticatedAdminIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    "/_authenticated/account/": {
      id: "/_authenticated/account/"
      path: "/"
      fullPath: "/account/"
      preLoaderRoute: typeof AuthenticatedAccountIndexRouteImport
      parentRoute: typeof AuthenticatedAccountRoute
    }
    "/_authenticated/sites/new": {
      id: "/_authenticated/sites/new"
      path: "/sites/new"
      fullPath: "/sites/new"
      preLoaderRoute: typeof AuthenticatedSitesNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/sites/$siteId": {
      id: "/_authenticated/sites/$siteId"
      path: "/sites/$siteId"
      fullPath: "/sites/$siteId"
      preLoaderRoute: typeof AuthenticatedSitesSiteIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/reimbursements/new": {
      id: "/_authenticated/reimbursements/new"
      path: "/reimbursements/new"
      fullPath: "/reimbursements/new"
      preLoaderRoute: typeof AuthenticatedReimbursementsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/reimbursements/ledger": {
      id: "/_authenticated/reimbursements/ledger"
      path: "/reimbursements/ledger"
      fullPath: "/reimbursements/ledger"
      preLoaderRoute: typeof AuthenticatedReimbursementsLedgerRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/reimbursements/$reimbursementId": {
      id: "/_authenticated/reimbursements/$reimbursementId"
      path: "/reimbursements/$reimbursementId"
      fullPath: "/reimbursements/$reimbursementId"
      preLoaderRoute: typeof AuthenticatedReimbursementsReimbursementIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/projects/new": {
      id: "/_authenticated/projects/new"
      path: "/projects/new"
      fullPath: "/projects/new"
      preLoaderRoute: typeof AuthenticatedProjectsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/projects/$projectId": {
      id: "/_authenticated/projects/$projectId"
      path: "/projects/$projectId"
      fullPath: "/projects/$projectId"
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/learning/$moduleId": {
      id: "/_authenticated/learning/$moduleId"
      path: "/learning/$moduleId"
      fullPath: "/learning/$moduleId"
      preLoaderRoute: typeof AuthenticatedLearningModuleIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/jobs/new": {
      id: "/_authenticated/jobs/new"
      path: "/jobs/new"
      fullPath: "/jobs/new"
      preLoaderRoute: typeof AuthenticatedJobsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/jobs/$jobId": {
      id: "/_authenticated/jobs/$jobId"
      path: "/jobs/$jobId"
      fullPath: "/jobs/$jobId"
      preLoaderRoute: typeof AuthenticatedJobsJobIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/clients/new": {
      id: "/_authenticated/clients/new"
      path: "/clients/new"
      fullPath: "/clients/new"
      preLoaderRoute: typeof AuthenticatedClientsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/clients/$clientId": {
      id: "/_authenticated/clients/$clientId"
      path: "/clients/$clientId"
      fullPath: "/clients/$clientId"
      preLoaderRoute: typeof AuthenticatedClientsClientIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/advances/new": {
      id: "/_authenticated/advances/new"
      path: "/advances/new"
      fullPath: "/advances/new"
      preLoaderRoute: typeof AuthenticatedAdvancesNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/advances/ledger": {
      id: "/_authenticated/advances/ledger"
      path: "/advances/ledger"
      fullPath: "/advances/ledger"
      preLoaderRoute: typeof AuthenticatedAdvancesLedgerRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/advances/$advanceId": {
      id: "/_authenticated/advances/$advanceId"
      path: "/advances/$advanceId"
      fullPath: "/advances/$advanceId"
      preLoaderRoute: typeof AuthenticatedAdvancesAdvanceIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/account/users": {
      id: "/_authenticated/account/users"
      path: "/users"
      fullPath: "/account/users"
      preLoaderRoute: typeof AuthenticatedAccountUsersRouteImport
      parentRoute: typeof AuthenticatedAccountRoute
    }
    "/_authenticated/account/sessions": {
      id: "/_authenticated/account/sessions"
      path: "/sessions"
      fullPath: "/account/sessions"
      preLoaderRoute: typeof AuthenticatedAccountSessionsRouteImport
      parentRoute: typeof AuthenticatedAccountRoute
    }
    "/_authenticated/account/profile": {
      id: "/_authenticated/account/profile"
      path: "/profile"
      fullPath: "/account/profile"
      preLoaderRoute: typeof AuthenticatedAccountProfileRouteImport
      parentRoute: typeof AuthenticatedAccountRoute
    }
    "/_authenticated/account/password": {
      id: "/_authenticated/account/password"
      path: "/password"
      fullPath: "/account/password"
      preLoaderRoute: typeof AuthenticatedAccountPasswordRouteImport
      parentRoute: typeof AuthenticatedAccountRoute
    }
    "/_authenticated/admin/visitors/": {
      id: "/_authenticated/admin/visitors/"
      path: "/visitors"
      fullPath: "/admin/visitors/"
      preLoaderRoute: typeof AuthenticatedAdminVisitorsIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    "/_authenticated/admin/users/": {
      id: "/_authenticated/admin/users/"
      path: "/users"
      fullPath: "/admin/users/"
      preLoaderRoute: typeof AuthenticatedAdminUsersIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    "/_authenticated/admin/roles/": {
      id: "/_authenticated/admin/roles/"
      path: "/roles"
      fullPath: "/admin/roles/"
      preLoaderRoute: typeof AuthenticatedAdminRolesIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    "/_authenticated/admin/organizations/": {
      id: "/_authenticated/admin/organizations/"
      path: "/organizations"
      fullPath: "/admin/organizations/"
      preLoaderRoute: typeof AuthenticatedAdminOrganizationsIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    "/_authenticated/admin/organization-profile/": {
      id: "/_authenticated/admin/organization-profile/"
      path: "/organization-profile"
      fullPath: "/admin/organization-profile/"
      preLoaderRoute: typeof AuthenticatedAdminOrganizationProfileIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    "/_authenticated/admin/audit-log/": {
      id: "/_authenticated/admin/audit-log/"
      path: "/audit-log"
      fullPath: "/admin/audit-log/"
      preLoaderRoute: typeof AuthenticatedAdminAuditLogIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    "/_authenticated/admin/approval-chains/": {
      id: "/_authenticated/admin/approval-chains/"
      path: "/approval-chains"
      fullPath: "/admin/approval-chains/"
      preLoaderRoute: typeof AuthenticatedAdminApprovalChainsIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    "/_authenticated/sites/$siteId_/edit": {
      id: "/_authenticated/sites/$siteId_/edit"
      path: "/sites/$siteId/edit"
      fullPath: "/sites/$siteId/edit"
      preLoaderRoute: typeof AuthenticatedSitesSiteIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/reimbursements/$reimbursementId_/edit": {
      id: "/_authenticated/reimbursements/$reimbursementId_/edit"
      path: "/reimbursements/$reimbursementId/edit"
      fullPath: "/reimbursements/$reimbursementId/edit"
      preLoaderRoute: typeof AuthenticatedReimbursementsReimbursementIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/projects/$projectId_/edit": {
      id: "/_authenticated/projects/$projectId_/edit"
      path: "/projects/$projectId/edit"
      fullPath: "/projects/$projectId/edit"
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/learning/$moduleId_/progress": {
      id: "/_authenticated/learning/$moduleId_/progress"
      path: "/learning/$moduleId/progress"
      fullPath: "/learning/$moduleId/progress"
      preLoaderRoute: typeof AuthenticatedLearningModuleIdProgressRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/jobs/$jobId_/edit": {
      id: "/_authenticated/jobs/$jobId_/edit"
      path: "/jobs/$jobId/edit"
      fullPath: "/jobs/$jobId/edit"
      preLoaderRoute: typeof AuthenticatedJobsJobIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/clients/$clientId_/edit": {
      id: "/_authenticated/clients/$clientId_/edit"
      path: "/clients/$clientId/edit"
      fullPath: "/clients/$clientId/edit"
      preLoaderRoute: typeof AuthenticatedClientsClientIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/advances/$advanceId_/edit": {
      id: "/_authenticated/advances/$advanceId_/edit"
      path: "/advances/$advanceId/edit"
      fullPath: "/advances/$advanceId/edit"
      preLoaderRoute: typeof AuthenticatedAdvancesAdvanceIdEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    "/_authenticated/admin/visitors/$groupId": {
      id: "/_authenticated/admin/visitors/$groupId"
      path: "/visitors/$groupId"
      fullPath: "/admin/visitors/$groupId"
      preLoaderRoute: typeof AuthenticatedAdminVisitorsGroupIdRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    "/_authenticated/admin/users/new": {
      id: "/_authenticated/admin/users/new"
      path: "/users/new"
      fullPath: "/admin/users/new"
      preLoaderRoute: typeof AuthenticatedAdminUsersNewRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    "/_authenticated/admin/users/$userId": {
      id: "/_authenticated/admin/users/$userId"
      path: "/users/$userId"
      fullPath: "/admin/users/$userId"
      preLoaderRoute: typeof AuthenticatedAdminUsersUserIdRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    "/_authenticated/admin/settings/vehicles/": {
      id: "/_authenticated/admin/settings/vehicles/"
      path: "/settings/vehicles"
      fullPath: "/admin/settings/vehicles/"
      preLoaderRoute: typeof AuthenticatedAdminSettingsVehiclesIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    "/_authenticated/admin/settings/service-types/": {
      id: "/_authenticated/admin/settings/service-types/"
      path: "/settings/service-types"
      fullPath: "/admin/settings/service-types/"
      preLoaderRoute: typeof AuthenticatedAdminSettingsServiceTypesIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    "/_authenticated/admin/settings/receipt-window/": {
      id: "/_authenticated/admin/settings/receipt-window/"
      path: "/settings/receipt-window"
      fullPath: "/admin/settings/receipt-window/"
      preLoaderRoute: typeof AuthenticatedAdminSettingsReceiptWindowIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    "/_authenticated/admin/settings/project-types/": {
      id: "/_authenticated/admin/settings/project-types/"
      path: "/settings/project-types"
      fullPath: "/admin/settings/project-types/"
      preLoaderRoute: typeof AuthenticatedAdminSettingsProjectTypesIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    "/_authenticated/admin/settings/mileage-rates/": {
      id: "/_authenticated/admin/settings/mileage-rates/"
      path: "/settings/mileage-rates"
      fullPath: "/admin/settings/mileage-rates/"
      preLoaderRoute: typeof AuthenticatedAdminSettingsMileageRatesIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    "/_authenticated/admin/settings/expense-categories/": {
      id: "/_authenticated/admin/settings/expense-categories/"
      path: "/settings/expense-categories"
      fullPath: "/admin/settings/expense-categories/"
      preLoaderRoute: typeof AuthenticatedAdminSettingsExpenseCategoriesIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    "/_authenticated/admin/settings/account-mapping/": {
      id: "/_authenticated/admin/settings/account-mapping/"
      path: "/settings/account-mapping"
      fullPath: "/admin/settings/account-mapping/"
      preLoaderRoute: typeof AuthenticatedAdminSettingsAccountMappingIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    "/_authenticated/admin/settings/account-codes/": {
      id: "/_authenticated/admin/settings/account-codes/"
      path: "/settings/account-codes"
      fullPath: "/admin/settings/account-codes/"
      preLoaderRoute: typeof AuthenticatedAdminSettingsAccountCodesIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
  }
}

interface AuthenticatedAccountRouteChildren {
  AuthenticatedAccountPasswordRoute: typeof AuthenticatedAccountPasswordRoute
  AuthenticatedAccountProfileRoute: typeof AuthenticatedAccountProfileRoute
  AuthenticatedAccountSessionsRoute: typeof AuthenticatedAccountSessionsRoute
  AuthenticatedAccountUsersRoute: typeof AuthenticatedAccountUsersRoute
  AuthenticatedAccountIndexRoute: typeof AuthenticatedAccountIndexRoute
}

const AuthenticatedAccountRouteChildren: AuthenticatedAccountRouteChildren = {
  AuthenticatedAccountPasswordRoute: AuthenticatedAccountPasswordRoute,
  AuthenticatedAccountProfileRoute: AuthenticatedAccountProfileRoute,
  AuthenticatedAccountSessionsRoute: AuthenticatedAccountSessionsRoute,
  AuthenticatedAccountUsersRoute: AuthenticatedAccountUsersRoute,
  AuthenticatedAccountIndexRoute: AuthenticatedAccountIndexRoute,
}

const AuthenticatedAccountRouteWithChildren =
  AuthenticatedAccountRoute._addFileChildren(AuthenticatedAccountRouteChildren)

interface AuthenticatedAdminRouteChildren {
  AuthenticatedAdminIndexRoute: typeof AuthenticatedAdminIndexRoute
  AuthenticatedAdminUsersUserIdRoute: typeof AuthenticatedAdminUsersUserIdRoute
  AuthenticatedAdminUsersNewRoute: typeof AuthenticatedAdminUsersNewRoute
  AuthenticatedAdminVisitorsGroupIdRoute: typeof AuthenticatedAdminVisitorsGroupIdRoute
  AuthenticatedAdminApprovalChainsIndexRoute: typeof AuthenticatedAdminApprovalChainsIndexRoute
  AuthenticatedAdminAuditLogIndexRoute: typeof AuthenticatedAdminAuditLogIndexRoute
  AuthenticatedAdminOrganizationProfileIndexRoute: typeof AuthenticatedAdminOrganizationProfileIndexRoute
  AuthenticatedAdminOrganizationsIndexRoute: typeof AuthenticatedAdminOrganizationsIndexRoute
  AuthenticatedAdminRolesIndexRoute: typeof AuthenticatedAdminRolesIndexRoute
  AuthenticatedAdminUsersIndexRoute: typeof AuthenticatedAdminUsersIndexRoute
  AuthenticatedAdminVisitorsIndexRoute: typeof AuthenticatedAdminVisitorsIndexRoute
  AuthenticatedAdminSettingsAccountCodesIndexRoute: typeof AuthenticatedAdminSettingsAccountCodesIndexRoute
  AuthenticatedAdminSettingsAccountMappingIndexRoute: typeof AuthenticatedAdminSettingsAccountMappingIndexRoute
  AuthenticatedAdminSettingsExpenseCategoriesIndexRoute: typeof AuthenticatedAdminSettingsExpenseCategoriesIndexRoute
  AuthenticatedAdminSettingsMileageRatesIndexRoute: typeof AuthenticatedAdminSettingsMileageRatesIndexRoute
  AuthenticatedAdminSettingsProjectTypesIndexRoute: typeof AuthenticatedAdminSettingsProjectTypesIndexRoute
  AuthenticatedAdminSettingsReceiptWindowIndexRoute: typeof AuthenticatedAdminSettingsReceiptWindowIndexRoute
  AuthenticatedAdminSettingsServiceTypesIndexRoute: typeof AuthenticatedAdminSettingsServiceTypesIndexRoute
  AuthenticatedAdminSettingsVehiclesIndexRoute: typeof AuthenticatedAdminSettingsVehiclesIndexRoute
}

const AuthenticatedAdminRouteChildren: AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute,
  AuthenticatedAdminUsersUserIdRoute: AuthenticatedAdminUsersUserIdRoute,
  AuthenticatedAdminUsersNewRoute: AuthenticatedAdminUsersNewRoute,
  AuthenticatedAdminVisitorsGroupIdRoute:
    AuthenticatedAdminVisitorsGroupIdRoute,
  AuthenticatedAdminApprovalChainsIndexRoute:
    AuthenticatedAdminApprovalChainsIndexRoute,
  AuthenticatedAdminAuditLogIndexRoute: AuthenticatedAdminAuditLogIndexRoute,
  AuthenticatedAdminOrganizationProfileIndexRoute:
    AuthenticatedAdminOrganizationProfileIndexRoute,
  AuthenticatedAdminOrganizationsIndexRoute:
    AuthenticatedAdminOrganizationsIndexRoute,
  AuthenticatedAdminRolesIndexRoute: AuthenticatedAdminRolesIndexRoute,
  AuthenticatedAdminUsersIndexRoute: AuthenticatedAdminUsersIndexRoute,
  AuthenticatedAdminVisitorsIndexRoute: AuthenticatedAdminVisitorsIndexRoute,
  AuthenticatedAdminSettingsAccountCodesIndexRoute:
    AuthenticatedAdminSettingsAccountCodesIndexRoute,
  AuthenticatedAdminSettingsAccountMappingIndexRoute:
    AuthenticatedAdminSettingsAccountMappingIndexRoute,
  AuthenticatedAdminSettingsExpenseCategoriesIndexRoute:
    AuthenticatedAdminSettingsExpenseCategoriesIndexRoute,
  AuthenticatedAdminSettingsMileageRatesIndexRoute:
    AuthenticatedAdminSettingsMileageRatesIndexRoute,
  AuthenticatedAdminSettingsProjectTypesIndexRoute:
    AuthenticatedAdminSettingsProjectTypesIndexRoute,
  AuthenticatedAdminSettingsReceiptWindowIndexRoute:
    AuthenticatedAdminSettingsReceiptWindowIndexRoute,
  AuthenticatedAdminSettingsServiceTypesIndexRoute:
    AuthenticatedAdminSettingsServiceTypesIndexRoute,
  AuthenticatedAdminSettingsVehiclesIndexRoute:
    AuthenticatedAdminSettingsVehiclesIndexRoute,
}

const AuthenticatedAdminRouteWithChildren =
  AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedSplatRoute: typeof AuthenticatedSplatRoute
  AuthenticatedAccountRoute: typeof AuthenticatedAccountRouteWithChildren
  AuthenticatedAdminRoute: typeof AuthenticatedAdminRouteWithChildren
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedAdvancesAdvanceIdRoute: typeof AuthenticatedAdvancesAdvanceIdRoute
  AuthenticatedAdvancesLedgerRoute: typeof AuthenticatedAdvancesLedgerRoute
  AuthenticatedAdvancesNewRoute: typeof AuthenticatedAdvancesNewRoute
  AuthenticatedClientsClientIdRoute: typeof AuthenticatedClientsClientIdRoute
  AuthenticatedClientsNewRoute: typeof AuthenticatedClientsNewRoute
  AuthenticatedJobsJobIdRoute: typeof AuthenticatedJobsJobIdRoute
  AuthenticatedJobsNewRoute: typeof AuthenticatedJobsNewRoute
  AuthenticatedLearningModuleIdRoute: typeof AuthenticatedLearningModuleIdRoute
  AuthenticatedProjectsProjectIdRoute: typeof AuthenticatedProjectsProjectIdRoute
  AuthenticatedProjectsNewRoute: typeof AuthenticatedProjectsNewRoute
  AuthenticatedReimbursementsReimbursementIdRoute: typeof AuthenticatedReimbursementsReimbursementIdRoute
  AuthenticatedReimbursementsLedgerRoute: typeof AuthenticatedReimbursementsLedgerRoute
  AuthenticatedReimbursementsNewRoute: typeof AuthenticatedReimbursementsNewRoute
  AuthenticatedSitesSiteIdRoute: typeof AuthenticatedSitesSiteIdRoute
  AuthenticatedSitesNewRoute: typeof AuthenticatedSitesNewRoute
  AuthenticatedAdvancesIndexRoute: typeof AuthenticatedAdvancesIndexRoute
  AuthenticatedClientsIndexRoute: typeof AuthenticatedClientsIndexRoute
  AuthenticatedInboxIndexRoute: typeof AuthenticatedInboxIndexRoute
  AuthenticatedJobsIndexRoute: typeof AuthenticatedJobsIndexRoute
  AuthenticatedJournalEntriesIndexRoute: typeof AuthenticatedJournalEntriesIndexRoute
  AuthenticatedLearningIndexRoute: typeof AuthenticatedLearningIndexRoute
  AuthenticatedPhotoReportTemplatesIndexRoute: typeof AuthenticatedPhotoReportTemplatesIndexRoute
  AuthenticatedProjectsIndexRoute: typeof AuthenticatedProjectsIndexRoute
  AuthenticatedReimbursementsIndexRoute: typeof AuthenticatedReimbursementsIndexRoute
  AuthenticatedSitesIndexRoute: typeof AuthenticatedSitesIndexRoute
  AuthenticatedWhatsNewIndexRoute: typeof AuthenticatedWhatsNewIndexRoute
  AuthenticatedAdvancesAdvanceIdEditRoute: typeof AuthenticatedAdvancesAdvanceIdEditRoute
  AuthenticatedClientsClientIdEditRoute: typeof AuthenticatedClientsClientIdEditRoute
  AuthenticatedJobsJobIdEditRoute: typeof AuthenticatedJobsJobIdEditRoute
  AuthenticatedLearningModuleIdProgressRoute: typeof AuthenticatedLearningModuleIdProgressRoute
  AuthenticatedProjectsProjectIdEditRoute: typeof AuthenticatedProjectsProjectIdEditRoute
  AuthenticatedReimbursementsReimbursementIdEditRoute: typeof AuthenticatedReimbursementsReimbursementIdEditRoute
  AuthenticatedSitesSiteIdEditRoute: typeof AuthenticatedSitesSiteIdEditRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedSplatRoute: AuthenticatedSplatRoute,
  AuthenticatedAccountRoute: AuthenticatedAccountRouteWithChildren,
  AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedAdvancesAdvanceIdRoute: AuthenticatedAdvancesAdvanceIdRoute,
  AuthenticatedAdvancesLedgerRoute: AuthenticatedAdvancesLedgerRoute,
  AuthenticatedAdvancesNewRoute: AuthenticatedAdvancesNewRoute,
  AuthenticatedClientsClientIdRoute: AuthenticatedClientsClientIdRoute,
  AuthenticatedClientsNewRoute: AuthenticatedClientsNewRoute,
  AuthenticatedJobsJobIdRoute: AuthenticatedJobsJobIdRoute,
  AuthenticatedJobsNewRoute: AuthenticatedJobsNewRoute,
  AuthenticatedLearningModuleIdRoute: AuthenticatedLearningModuleIdRoute,
  AuthenticatedProjectsProjectIdRoute: AuthenticatedProjectsProjectIdRoute,
  AuthenticatedProjectsNewRoute: AuthenticatedProjectsNewRoute,
  AuthenticatedReimbursementsReimbursementIdRoute:
    AuthenticatedReimbursementsReimbursementIdRoute,
  AuthenticatedReimbursementsLedgerRoute:
    AuthenticatedReimbursementsLedgerRoute,
  AuthenticatedReimbursementsNewRoute: AuthenticatedReimbursementsNewRoute,
  AuthenticatedSitesSiteIdRoute: AuthenticatedSitesSiteIdRoute,
  AuthenticatedSitesNewRoute: AuthenticatedSitesNewRoute,
  AuthenticatedAdvancesIndexRoute: AuthenticatedAdvancesIndexRoute,
  AuthenticatedClientsIndexRoute: AuthenticatedClientsIndexRoute,
  AuthenticatedInboxIndexRoute: AuthenticatedInboxIndexRoute,
  AuthenticatedJobsIndexRoute: AuthenticatedJobsIndexRoute,
  AuthenticatedJournalEntriesIndexRoute: AuthenticatedJournalEntriesIndexRoute,
  AuthenticatedLearningIndexRoute: AuthenticatedLearningIndexRoute,
  AuthenticatedPhotoReportTemplatesIndexRoute:
    AuthenticatedPhotoReportTemplatesIndexRoute,
  AuthenticatedProjectsIndexRoute: AuthenticatedProjectsIndexRoute,
  AuthenticatedReimbursementsIndexRoute: AuthenticatedReimbursementsIndexRoute,
  AuthenticatedSitesIndexRoute: AuthenticatedSitesIndexRoute,
  AuthenticatedWhatsNewIndexRoute: AuthenticatedWhatsNewIndexRoute,
  AuthenticatedAdvancesAdvanceIdEditRoute:
    AuthenticatedAdvancesAdvanceIdEditRoute,
  AuthenticatedClientsClientIdEditRoute: AuthenticatedClientsClientIdEditRoute,
  AuthenticatedJobsJobIdEditRoute: AuthenticatedJobsJobIdEditRoute,
  AuthenticatedLearningModuleIdProgressRoute:
    AuthenticatedLearningModuleIdProgressRoute,
  AuthenticatedProjectsProjectIdEditRoute:
    AuthenticatedProjectsProjectIdEditRoute,
  AuthenticatedReimbursementsReimbursementIdEditRoute:
    AuthenticatedReimbursementsReimbursementIdEditRoute,
  AuthenticatedSitesSiteIdEditRoute: AuthenticatedSitesSiteIdEditRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  ReportTokenRoute: ReportTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
